import React from "react";
import { ModalProvider } from "react-modal-hook";
import Card from './card';

import PortfolioDatas from "../contents/PortfolioDatas";

const Portfolio = () =>{
    return (
    <section id='portfolio'>
      <div>
      <h2>Mes Projets</h2>

            {PortfolioDatas.map((portfolio) => {
              return (
                <ModalProvider>
                <Card 
                portfolio={portfolio}
                />
                </ModalProvider>
              );
            })}
        </div>
    </section>
  );
};

export default Portfolio;
